import { render, staticRenderFns } from "./serviceDialog.vue?vue&type=template&id=47615dec&scoped=true&"
import script from "./serviceDialog.vue?vue&type=script&lang=js&"
export * from "./serviceDialog.vue?vue&type=script&lang=js&"
import style0 from "./serviceDialog.vue?vue&type=style&index=0&id=47615dec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47615dec",
  null
  
)

export default component.exports